export const removeOldDuplicatesBy = <T>(
  data: T[],
  getId: (entry: T) => string
) => {
  return data.reduce((entries, current) => {
    const elm = entries.find((entry) => getId(entry) === getId(current));
    const index = elm ? entries.indexOf(elm) : -1;

    if (index >= 0) {
      entries[index] = current;
    }
    return index === -1 ? [...entries, current] : entries;
  }, [] as T[]);
};
